import { render, staticRenderFns } from "./HealthPlanSettings.vue?vue&type=template&id=0fb3ff8b&scoped=true"
import script from "./HealthPlanSettings.vue?vue&type=script&lang=ts"
export * from "./HealthPlanSettings.vue?vue&type=script&lang=ts"
import style0 from "./HealthPlanSettings.vue?vue&type=style&index=0&id=0fb3ff8b&prod&lang=scss"
import style1 from "./HealthPlanSettings.vue?vue&type=style&index=1&id=0fb3ff8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb3ff8b",
  null
  
)

export default component.exports